import { useQuery } from "@tanstack/react-query";
import { getProjectOverview } from "@/app/actions/project/overview/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProjectOverview(projectId?: number, enabled = true) {
  return useQuery({
    queryKey: [QueryKey.PROJECT_OVERVIEW, projectId],
    queryFn: () => getProjectOverview(projectId!),
    enabled: enabled && !!projectId,
    staleTime: Infinity,
  });
}
